import { DashboardBreakdownType } from "..";
import { RandomGenerator } from "../../test-utils";
export var createChatDashboardData = function (itemsLength, withUnassigned, chatDashboardBreakdownType) {
    if (itemsLength === void 0) { itemsLength = 5; }
    var items = new Array(itemsLength).fill(0).map(function (_, idx) { return ({
        realtimeData: {
            totalWaiting: RandomGenerator.randomNumber(1),
            totalActive: RandomGenerator.randomNumber(1),
            longestActiveTicket: {
                ticketId: RandomGenerator.randomTicket().id,
                statusStartDate: 1623847737018
            },
            lastFiveMinutes: RandomGenerator.randomNumber(),
            longestWaitingTicket: {
                ticketId: RandomGenerator.randomTicket().id,
                statusStartDate: 1623847737018
            },
            totalWaitingTransferred: RandomGenerator.randomNumber(),
        },
        itemName: withUnassigned && (idx === 0 || idx === 1) ? 'Unassigned' : chatDashboardBreakdownType === DashboardBreakdownType.LANGUAGE ?
            RandomGenerator.randomLocale() : RandomGenerator.randomString(),
        itemId: (withUnassigned && (idx === 0 || idx === 1)) || chatDashboardBreakdownType === DashboardBreakdownType.LANGUAGE ? undefined : RandomGenerator.randomId(),
        agentStats: createRealtimeRecordAgentStats(),
        timeframeStats: createRealtimeDashboardTimeframeStats(),
    }); });
    return ({
        items: items,
        itemsCount: itemsLength,
    });
};
export var createChatDashboardStats = function () {
    return ({
        realtimeData: {
            totalWaiting: RandomGenerator.randomNumber(),
            totalActive: RandomGenerator.randomNumber(),
            longestActiveTicket: {
                ticketId: RandomGenerator.randomTicket().id,
                statusStartDate: 1623847737018
            },
            lastFiveMinutes: RandomGenerator.randomNumber(),
            longestWaitingTicket: {
                ticketId: RandomGenerator.randomTicket().id,
                statusStartDate: 1623847737018
            },
            totalWaitingTransferred: RandomGenerator.randomNumber(),
        },
        agentStats: createRealtimeRecordAgentStats(),
        timeframeStats: createRealtimeDashboardTimeframeStats()
    });
};
export var createRealtimeRecordAgentStats = function () {
    var totalAgents = RandomGenerator.randomNumber(3);
    var totalActive = RandomGenerator.randomNumber(1, totalAgents - 2);
    var totalBusy = RandomGenerator.randomNumber(1, totalAgents - totalActive - 1);
    var totalAvailable = RandomGenerator.randomNumber(1, totalAgents - totalActive - totalBusy);
    var maxWorkload = RandomGenerator.randomNumber(1);
    var activeTickets = RandomGenerator.randomNumber();
    var haveAgentsInMultipleRecords = RandomGenerator.randomBoolean();
    return ({
        haveAgentsInMultipleRecords: haveAgentsInMultipleRecords,
        totalAgents: totalAgents,
        totalActive: totalActive,
        totalBusy: totalBusy,
        totalAvailable: totalAvailable,
        maxWorkload: maxWorkload,
        activeTickets: activeTickets
    });
};
export var createRealtimeDashboardTimeframeStats = function () {
    var avgChatDuration = RandomGenerator.randomNumber(1);
    var avgFirstResponseDuration = RandomGenerator.randomNumber(1);
    var chatPositiveCsats = RandomGenerator.randomNumber(1);
    var chatTotalCsats = RandomGenerator.randomNumber(1);
    var completedChats = RandomGenerator.randomNumber(1);
    var totalChats = RandomGenerator.randomNumber(1);
    var totalTransferred = RandomGenerator.randomNumber(1);
    return ({
        avgChatDuration: avgChatDuration,
        avgFirstResponseDuration: avgFirstResponseDuration,
        chatPositiveCsats: chatPositiveCsats,
        chatTotalCsats: chatTotalCsats,
        completedChats: completedChats,
        totalChats: totalChats,
        totalTransferred: totalTransferred
    });
};
//# sourceMappingURL=builders.js.map